import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=1aed6807&scoped=true"
const script = {}

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=1aed6807&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aed6807"]])

export default __exports__